// extracted by mini-css-extract-plugin
export default {"numericField":"InputFieldNumeric-module__numericField-UbxTFK"};